import React from 'react'
import './Service.css'
import WebDevIcon from '../../assets/WebDev.PNG'

function Service({src, title, description}) {
    return (
        <div className="service">
            <img src={src} alt=""/>
            <h2>{title}</h2>
            <div className="service__info">
            <p>
                {description}
            </p>
            </div>
        </div>
    )
}

export default Service
